import { render, staticRenderFns } from "./materialType.vue?vue&type=template&id=3a85df70&scoped=true"
import script from "./materialType.vue?vue&type=script&lang=js"
export * from "./materialType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a85df70",
  null
  
)

export default component.exports